var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaderecha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7826 7.33507L7.20663 3.75907L8.1493 2.81641L13.3346 8.00174L8.1493 13.1871L7.20663 12.2444L10.7826 8.66841H2.66797V7.33507H10.7826Z",
    fill: "#03053D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaderecha);
export default __webpack_public_path__ + "static/media/flecha derecha.11aa662571937134ad26bbde43c179c4.svg";
export { ForwardRef as ReactComponent };